import App from '../App/App.js';
import gsap from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollSmoother } from 'gsap/ScrollSmoother';
import { Power4 } from 'gsap/gsap-core';
import Section from '../Sections/Section';
import Page from '../Layout/Page/Page';

gsap.registerPlugin(ScrollTrigger, ScrollSmoother, ScrollToPlugin, Power4);

const Scroller = {
	selected: '',
	trashHold: 5,
	changeUrlOnAnchors: false,
	animTime: 1,
	yOffset: 90,
	loadingDelay: 500,

	init(collection) {

		collection = collection ? collection : $('body');

		if (App.debug) {
			console.log('Scroller.init()  ---------------------');
			console.log(collection);
		}

		this.sections = $('[component="Page"] section[id]');
		this.initScrollToAnchor();
		// Page.init();
		// Section.init();
		// if (App.isIphone || window.killSmoothScroller) return;
		// this.InitSmoother();

	},

	InitSmoother() {
		this.smoother = ScrollSmoHother.create({
			smooth: 0.5,
			effects: true,
			smoothTouch: 0.1,
			normalizeScroll: false,
		});
	},

	initScrollToAnchor() {
		const anchors = $('a[href*="#"]');

		anchors.on('click', (evt) => {
			const link = evt.currentTarget;

			if (
				location.pathname.replace(/^\//, '') === link.pathname.replace(/^\//, '') &&
				location.hostname === link.hostname
			) {
				const target = $(link.hash);
				const $target = target.length ? target : $('[name=' + link.hash.slice(1) + ']');

				if ($target.length) {
					evt.preventDefault();
					this.scrollToAnchor($target, true);
				}
			}
		});

		if (window.location.hash) {
			const initialSection = $(window.location.hash);
			console.log('initialSection', initialSection, window.location.hash);
			if (initialSection.length) {
				window.scrollTo(0, 0);
				this.scrollToAnchor(initialSection);
			}
		}
	},
	scrollToAnchor(section, immediate = false) {

		const submenu = $('header.menu');
		const header = $('[component="Header"]');
		let offset = submenu.length > 0 ? submenu.outerHeight() : 0;
		offset = offset + (!header.is('.hidden') ? header.outerHeight() : 0);
		const delay = immediate ? 0 : this.loadingDelay;

		setTimeout(() => {
			gsap.to(window, {
				duration: Scroller.animTime,
				scrollTo: { y: section, offsetY: offset },
				ease: 'power2.out',
			});
		}, delay);

	},

	goTop() {
		// ak nepouzivam JS scrollbar
		// $('[component="Page"]').animate({ "scrollTop": 0 }, 700, "easeInOutQuint", function() {
		$('html, body').animate({ 'scrollTop': 0 }, 700, 'easeInOutQuint', function() {
			Scroller.isScrolling = false;
		});
	},
};

export default Scroller;